var path = 'app/components/common/forms/templates/errorMessages.html';
var html = "<div ng-message=\"required\" class=\"field-error-messages\">Obavezno polje</div><div ng-message=\"minlength\" class=\"field-error-messages\">Unos je predug</div><div ng-message=\"maxlength\" class=\"field-error-messages\">Unos je prekratak</div><div ng-message=\"email\" class=\"field-error-messages\">Neispravna e-mail adresa</div><div ng-message=\"datemask\" class=\"field-error-messages\">Neispravan datum</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/common/forms/templates/errorMessages.html
// module id = 321
// module chunks = 0